import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Logo from './components/Logo';
import { useTranslation } from 'react-i18next';
import './LinkedInTheme.css';

function Marketing() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleLoginRedirect = () => {
    navigate('/login');
  };

  const handleRequestDemo = () => {
    const subject = "Request for POD+ Demo";
    const body = `
I'd like to request a demo of the POD+ Talent Intelligence Platform.

Please provide the following information:

- Business Name: [Enter Business Name]
- Contact Name: [Enter Your Name]
- Email Address: [Enter Your Email]
- Phone Number: [Enter Your Phone Number]
- Location: [Enter Your Location]

Thank you!
    `;
    window.location.href = `mailto:glabs@gclouds.co.uk?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  return (
    <div className="li-auth-wrapper">
      {/* Header */}
      <header className="li-auth-header">
        <div className="li-auth-header-content">
           <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
             <Logo size={32} />
           </div>
           <div>
              <button onClick={handleLoginRedirect} className="li-btn-primary" style={{ marginLeft: '12px' }}>{t('marketing.signIn')}</button>
           </div>
        </div>
      </header>

      <main style={{ width: '100%' }}>
        {/* Hero */}
        <section className="li-auth-hero">
           <div className="li-auth-hero-content">
              <h1 className="li-auth-hero-headline" style={{ fontSize: '48px' }}>
                {t('marketing.heroHeadline1')} <br/>
                <span style={{ color: '#8f5849', fontWeight: '200' }}>{t('marketing.heroHeadline2')}</span>
              </h1>
              <p style={{ fontSize: '20px', color: 'rgba(0,0,0,0.6)', marginBottom: '32px', lineHeight: '1.5', fontWeight: '200' }}>
                {t('marketing.heroSubheadline')}
              </p>
              <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                <button onClick={handleLoginRedirect} className="li-btn-primary" style={{ padding: '12px 32px', borderRadius: '28px', fontSize: '18px' }}>
                  {t('marketing.getStarted')}
                </button>
                <button onClick={handleRequestDemo} className="li-btn-outline-secondary" style={{ padding: '12px 32px', borderRadius: '28px', fontSize: '18px' }}>
                  {t('marketing.requestDemo')}
                </button>
              </div>
           </div>
           <div className="li-auth-hero-image">
              <img src="/Flat_illutrations/diverse_group_in_garden.png" alt="Talent Pool" />
           </div>
        </section>

        {/* Features Grid */}
        <section className="li-section" style={{ backgroundColor: '#fff' }}>
           <div className="li-section-content">
              <h2 className="li-section-header" style={{ textAlign: 'center', width: '100%' }}>{t('marketing.heroTitle')}</h2>
              <p className="li-section-subhead" style={{ textAlign: 'center', width: '100%' }}>
                 {t('marketing.featuresSubhead')}
              </p>
              
              <div className="li-tile-grid" style={{ marginTop: '40px' }}>
                 {/* Feature 1 */}
                 <div className="li-tile">
                    <img src="/Flat_illutrations/simulation.png" alt="Living Profile" className="li-tile-img" />
                    <h3 className="li-tile-title">{t('marketing.livingProfileTitle')}</h3>
                    <p className="li-tile-text">
                       {t('marketing.livingProfileText')}
                    </p>
                 </div>

                 {/* Feature 2 */}
                 <div className="li-tile">
                    <img src="/Flat_illutrations/loon_ladder.png" alt="Opportunity Marketplace" className="li-tile-img" />
                    <h3 className="li-tile-title">{t('marketing.internalMarketplace')}</h3>
                    <p className="li-tile-text">
                       {t('marketing.internalMarketplaceText')}
                    </p>
                 </div>

                 {/* Feature 3 */}
                 <div className="li-tile">
                    <img src="/Flat_illutrations/Dashboard.png" alt="Predictive Analytics" className="li-tile-img" />
                    <h3 className="li-tile-title">{t('marketing.predictiveAnalytics')}</h3>
                    <p className="li-tile-text">
                       {t('marketing.predictiveAnalyticsText')}
                    </p>
                 </div>
              </div>
           </div>
        </section>

        {/* CTA Banner */}
        <section className="li-cta-banner">
           <h2 className="li-cta-header">{t('marketing.ctaHeader')}</h2>
           <button onClick={handleRequestDemo} className="li-btn-primary" style={{ padding: '12px 24px', fontSize: '18px' }}>
              {t('marketing.ctaButton')}
           </button>
        </section>

      </main>

      <footer className="li-footer-links" style={{ padding: '24px', borderTop: '1px solid #e0e0e0', width: '100%', backgroundColor: '#fff', textAlign: 'center' }}>
         <div className="container" style={{ textAlign: 'center' }}>
            <Link to="/about" style={{ margin: '0 12px', color: 'rgba(0,0,0,0.6)', textDecoration: 'none' }}>{t('footer.about')}</Link>
            <Link to="/accessibility" style={{ margin: '0 12px', color: 'rgba(0,0,0,0.6)', textDecoration: 'none' }}>{t('footer.accessibility')}</Link>
            <Link to="/help-center" style={{ margin: '0 12px', color: 'rgba(0,0,0,0.6)', textDecoration: 'none' }}>{t('footer.helpCenter')}</Link>
            <Link to="/privacy-terms" style={{ margin: '0 12px', color: 'rgba(0,0,0,0.6)', textDecoration: 'none' }}>{t('footer.privacyTerms')}</Link>
            <p style={{ marginTop: '16px', fontSize: '12px', color: 'rgba(0,0,0,0.6)' }}>{t('auth.footer.rights')}</p>
         </div>
      </footer>
    </div>
  );
}

export default Marketing;